export class DistritoModel {

  id: number;
  nombre: string;

  constructor() {
    this.nombre = '';
  }
}
